import { routesPath } from './routesPath';

export const menuItems = [
    { key: 'my-reports', route: routesPath.ROOT.DASHBOARD, iconName: 'myReports' },
    { key: 'settings', route: routesPath.ROOT.USER_SETTINGS, iconName: 'settings' },
    {
        key: 'transactions',
        route: routesPath.ROOT.TRANSACTIONS,
        iconName: 'transactions',
    },
];
